import { render, staticRenderFns } from "./addGroupBuyProduct.vue?vue&type=template&id=325f484c&scoped=true"
import script from "./addGroupBuyProduct.vue?vue&type=script&lang=js"
export * from "./addGroupBuyProduct.vue?vue&type=script&lang=js"
import style0 from "./addGroupBuyProduct.vue?vue&type=style&index=0&id=325f484c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f484c",
  null
  
)

export default component.exports